import { post } from "@insite/client-framework/Services/ApiService";


export interface QuoteEmailParameter {
    quoteNumber: string;
    emailTo: string;
    emailFrom: string;
    subject: string;
    message: string;
}

export interface SendQuoteEmailResult {
    isSuccess: boolean;
}

const url = "api/v1/quoteEmail";

export function sendQuoteEmailService(quoteEmailParameter : QuoteEmailParameter) {
   try {
        const result =  post<QuoteEmailParameter,SendQuoteEmailResult>(url,quoteEmailParameter)
        return {
            successful: true
        }
   } catch (error) {
       return {
           successful: false
       }
   }
}
    